import client from "../utils/client";

export const getStatistics = (): Promise<Data<Statistics>> =>
  client.get("/competitor/competitions-statistics");
